// extracted by mini-css-extract-plugin
export var backdropBlur = "_dt-0";
export var contentCard = "_dt-5";
export var frame = "_dt-2";
export var image = "_dt-4";
export var imagePane = "_dt-3";
export var modal = "_dt-1";